import React, { useEffect, useMemo, useState } from 'react'
import axios from '../../../utils/axiosConfig';
import Swal from 'sweetalert2';
import { Col, Row } from 'reactstrap';
import ModalBaseSm from '../../modals/modal-base-sm';
import FormModalCreatePropietario from '../forms/formModalCreatePropietario';

const ModalPropietarios = ({ bitInserts, bitEdits, bitDeletes }) => {
    const [id, setId] = useState(-1);
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [cedula, setCedula] = useState('');
    const [propietarios, setPropietarios] = useState([]);

    const [dialogOpen, setDialogOpen] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return propietarios;
        return propietarios.filter(item => {
            return Object.values(item).some(val =>
                String(val || '')
                    .toLowerCase()
                    .includes(debouncedTerm)
            );
        });
    }, [propietarios, debouncedTerm]);

    const listarPropietarios = async () => {
        try {
            await axios.get(
                process.env.REACT_APP_SERVER + '/maestros/getpropietario',
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            )
                .then((response) => {
                    if (response.data?.success) {
                        console.log('Propietarios listados:', response.data.data);
                        setPropietarios(response.data.data);
                    } else {
                        Swal.fire('Error', 'No se pudieron listar los propietarios', 'error');
                    }
                });
        } catch (error) {
            console.error('Error al listar propietarios:', error);
            Swal.fire('Error', 'Ocurrió un error al listar los propietarios', 'error');
        }
    }

    const toggleDialog = () => {
        setDialogOpen(o => !o);
        if (dialogOpen) {
            setNombre('');
            setCelular('');
            setEmail('');
            setId(-1);
            setCedula('');
        }
    };

    const editarPropietario = (item) => {
        setId(parseInt(item.IdPropietario));
        setNombre(item.NombrePropietario || '');
        setEmail(item.EmailPropietario || '');
        setCelular(item.CelularPropietario || '');
        setCedula(item.IdPropietario || '');
        setDialogOpen(true);
    }

    const guardar = ({ nombre, email, celular, cedula }) => {
        if (!email.trim() || !nombre.trim() || !celular.trim() || !cedula.trim()) {
            Swal.fire('Error', 'Debe completar Email, Nombre, Celular y Cédula', 'error');
            return;
        }

        const payloadCreate = {
            id: -1,
            IdPropietario: cedula,
            EmailPropietario: email,
            NombrePropietario: nombre,
            CelularPropietario: celular
        };

        axios.post(
            process.env.REACT_APP_SERVER + '/maestros/setpropietario',
            JSON.stringify(payloadCreate),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true
            }
        )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                Swal.fire('Éxito', 'Propietario guardado', 'success');
                listarPropietarios();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() => Swal.fire('Error', 'No se pudo guardar', 'error'));
    };

    const update = ({ nombre, email, celular }) => {
        if (!email.trim() || !nombre.trim() || !celular.trim()) {
            Swal.fire('Error', 'Debe completar Email, Nombre y Celular', 'error');
            return;
        }

        const payloadUpdate = {
            EmailPropietario: email,
            NombrePropietario: nombre,
            CelularPropietario: celular,
            id: id
        };

        axios.post(
            process.env.REACT_APP_SERVER + '/maestros/setpropietario',
            JSON.stringify(payloadUpdate),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true
            }
        )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo actualizar', 'error');
                    return;
                }
                Swal.fire('Éxito', 'Propietario actualizado', 'success');
                listarPropietarios();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() => Swal.fire('Error', 'No se pudo actualizar', 'error'));
    }

    const handleSaveOrUpdate = ({ nombre, email, celular, cedula }) => {
        if (id === -1) {
            guardar({ nombre, email, celular, cedula });
        } else {
            update({ nombre, email, celular });
        }
    };

    const limpiarCampos = () => {
        setNombre('');
        setEmail('');
        setCelular('');
        setId(-1);
        setCedula('');
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedTerm(searchTerm.trim().toLowerCase());
        }, 300);
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarPropietarios();
    }, []);


    return (
        <>
            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                    @media (max-width: 575.98px) {
                        .btn-nuevo-propietario {
                            width: 100%;
                        }
                    }
                `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="6">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar propietario..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>

                <Col
                    sm="6"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-propietario"
                        onClick={() => { if (bitInserts) toggleDialog(); }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Propietario
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#ffffff', width: '25%' }}>Nombre</th>
                                <th style={{ color: '#ffffff', textAlign: 'center' , width: '15%'}}>Cédula</th>
                                <th style={{ color: '#ffffff', textAlign: 'center' , width: '25%'}}>Email</th>
                                <th style={{ color: '#ffffff', textAlign: 'center' }}>Celular</th>
                                <th style={{ color: '#ffffff', textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000' }}>{item.NombrePropietario || '-'}</td>

                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {item.IdPropietario || '-'}
                                    </td>

                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {item.EmailPropietario || '-'}
                                    </td>

                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {item.CelularPropietario || '-'}
                                    </td>

                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits) editarPropietario(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </div>

            <ModalBaseSm
                isOpen={dialogOpen}
                onClose={toggleDialog}
                title={id === -1 ? 'Crear Propietario' : 'Editar Propietario'}
                childComponent={
                    <FormModalCreatePropietario
                        initialData={{ nombre, email, celular, cedula }}
                        onSave={handleSaveOrUpdate}
                    />
                }
            />
        </>
    )
}

export default ModalPropietarios
